import {
  Button,
  Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress,
} from '@mui/material';
import AutoCompleteContext from 'components/CustomInputsInFormikContext/AutoComplete';
import NumberFormatContext from 'components/CustomInputsInFormikContext/NumberFormat';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import { FormikProvider, useFormik } from 'formik';
import { labelField } from 'utils';
import { useSelector } from 'react-redux';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { useEffect, useState } from 'react';
import api from 'services/api';
import * as Yup from 'yup';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import CycleService from 'services/CycleService';

function CycleModal({
  openCycleModal,
  openLinearProgress,
  setOpenCycleModal,
  setOpenLinearProgress,
  updateCycles,
}) {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );

  const [isLoading, setIsLoading] = useState(true);
  const [ponds, setPonds] = useState([]);

  const {
    requestCompleted, loadingRequest, error, success,
  } = useDependencyInjection();

  const formik = useFormik({
    initialValues: {
      pond: null,
      cycleCode: selectedCycle,
      begin: null,
      end: null,
      population: 0,
      description: '1',
      status: POND_STATUS_CYCLE.PREPARANDO,
      observation: '',
    },
    validationSchema: Yup.object({
      pond: Yup.object().required('Campo Obrigatório').nullable(),
      population: Yup.number()
        .integer()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0')
        .typeError('O valor deve ser um número.')
        .max(
          999999999,
          'Valor máximo ultrapassado. Diminua o tamanho da amostra',
        ),
      observation: Yup.string().max(
        100,
        'Máximo de caracteres ultrapassado (100 caracteres).',
      ),
    }),
    onSubmit: (values) => {
      const payload = {
        ...values,
        pond: values.pond.id,
      };

      if (formik.isValid) {
        request(payload);
        setOpenCycleModal(false);
      }
    },
  });

  async function request(data) {
    // envia os dados para api salvar no banco
    loadingRequest();
    try {
      await api.post('/cycles', { ...data });
      const updatedPondCycles = await CycleService.pondsAvailableToPopulate(selectedCycle.id);
      updateCycles(updatedPondCycles);
      setOpenLinearProgress(false);
      success();
    } catch (err) {
      error(err.response.data.message);
    } finally {
      setOpenLinearProgress(false);
      requestCompleted();
    }
  }

  useEffect(() => {
    async function loadPonds() {
      setIsLoading(true);
      try {
        const recPonds = await api.get(`/ponds/availables/${selectedCycle.id}`);
        if (formik.values.pond && !recPonds.data.find((v) => v.id === formik.values.pond.id)) {
          formik.setFieldValue('pond', null);
        }
        setPonds([...recPonds.data].reverse());
      } catch (e) {
        // Handle error
      } finally {
        setIsLoading(false);
      }
    }
    loadPonds();
  }, [formik.values.pond, selectedCycle.id]);

  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenCycleModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenCycleModal(false);
    }
  };

  return (
    <Dialog
      style={{ padding: '15rem' }}
      open={openCycleModal}
      fullWidth
      maxWidth="lg"
      onClose={handleCloseModal}
    >
      {openLinearProgress && <LinearProgress />}
      <DialogTitle>
        <span>Viveiro no ciclo</span>
      </DialogTitle>
      <DialogContent sx={{
        '&.MuiDialogContent-root': {
          pt: 1,
        },
      }}
      >
        <form onSubmit={formik.handleSubmit}>
          <FormikProvider value={formik}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <AutoCompleteContext
                  disabled={isLoading}
                  label={labelField('Viveiro')}
                  name="pond"
                  options={ponds}
                  getOptionLabel={(options) => options.description}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberFormatContext
                  label={labelField('População atual', 'População atual (quantidade de animais)', false)}
                  name="population"
                  disabled
                  decimalScale={0}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextFieldContext
                  label={labelField('Observações (Opcional)', false, false)}
                  name="observation"
                />
              </Grid>
            </Grid>
          </FormikProvider>
          <DialogActions sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '2.5rem',
            padding: 0,
          }}
          >
            <Button
              fullWidth
              variant="outlined"
              onClick={() => setOpenCycleModal(false)}
              // disabled={formik.isSubmitting}
              style={{
                border: '1px solid red',
                color: 'red',
                borderRadius: '10px',
                padding: 8,
              }}
            >
              Cancelar
            </Button>
            <Button
              fullWidth
              type="submit"
              // disabled={formik.isSubmitting}
              style={{
                backgroundColor: '#0267C1',
                color: 'white',
                borderRadius: '10px',
                padding: 8,
              }}
            >
              Adicionar
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default CycleModal;
